import Gooey, { mount, Component, Dyn, dynSet } from '@srhazi/gooey';

export const StringInput: Component<{
    value: Dyn<string>;
    id?: Dyn<string>;
}> = ({ value, id }) => {
    return (
        <input
            on:input={(e, el) => {
                dynSet(value, el.value);
            }}
            value={value}
            id={id}
            type="string"
        />
    );
};
